import { useEffect, useState } from "react";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import PopupAlert from "../components/PopupAlert";
import AdminDashboard from "../pages/admin/AdminDashboard";
import AdminUserComponent from "../pages/admin/AdminUserComponent";
import AllAdminsComponent from "../pages/admin/AllAdminsComponent";

const AdminRoute = () => {
  const link = "https://api.dashboard.bhumu.com";
  // const link = "http://localhost:7051";
  // const link = "http://192.168.1.4:7051";

  const [userVerified, setUserVerified] = useState(false);

  const [companyList, setCompanyList] = useState(false);
  const [viewCompany, setViewCompany] = useState("Garage On Call");

  const navigate = useNavigate();

  const verifyUser = async () => {
    try {
      const response = await fetch(`${link}/admin/verify`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-type": "application/json",
        },
      });

      if (response.ok) {
        const respData = await response.json();
        const role = respData.user.role;

        if (role === "user") {
          navigate("/dashboard");
        }
        setUserVerified(true);
      } else {
        navigate("/");
      }
    } catch (error) {
      navigate("/");
    }
  };

  useEffect(() => {
    verifyUser();
  }, []);

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const logout = async () => {
    try {
      const response = await fetch(`${link}/logout`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-type": "application/json",
        },
      });

      if (response.ok) {
        navigate("/");
      } else {
        alert("Logout Error");
      }
    } catch (error) {
      alert("Server Error");
    }
  };

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const [showlogOut, setShowLogout] = useState(null);

  const [showNav, setShowNav] = useState(null);

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  return (
    <div>
      {userVerified ? (
        ""
      ) : (
        <div className="full-page-fixed-component">Verifying......</div>
      )}

      {showlogOut ? (
        <div className="dboard-log-out-alert-n">
          <PopupAlert
            heading="Are you sure you want to log out?"
            icon="fa-solid fa-right-from-bracket"
            open={setShowLogout}
            action={logout}
          />
        </div>
      ) : (
        ""
      )}

      <div>
        <div className="goc-dash-bord-container">
          <div className="goc-dash-bord-container-main">
            <div>
              <div className="goc-dashbord-left-side-menu-container">
                <div
                  onClick={() => setCompanyList(!companyList)}
                  className="goc-dashbord-left-side-menu-head"
                >
                  {viewCompany}
                  {companyList ? (
                    <i className="fa-solid fa-angle-down"></i>
                  ) : (
                    <i className="fa-solid fa-angle-right"></i>
                  )}
                  {companyList ? (
                    <div className="goc-dashbord-left-side-menu-list">
                      <div
                        onClick={() => {
                          setViewCompany("Garage On Call");
                        }}
                      >
                        Garage On Call
                      </div>
                      <div
                        onClick={() => {
                          setViewCompany("Repair Buddy");
                        }}
                      >
                        Repair Buddy
                      </div>
                      <div
                        onClick={() => {
                          setViewCompany("Fluffy Touch");
                        }}
                      >
                        Fluffy Touch
                      </div>
                      <div
                        onClick={() => {
                          setViewCompany("Glazma");
                        }}
                      >
                        Glazma
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div className="goc-dashbord-left-side-menu-main-items-cont">
                  <div className="goc-dashbord-left-side-menu-items">
                    {/* <Link to="">
                    <i class="fa-solid fa-house"></i>DashBoard
                  </Link> */}

                    <Link to="/admin">
                      {" "}
                      <i class="fa-solid fa-bookmark"></i>Bookings
                    </Link>
                    <Link to="/admin/users">
                      {" "}
                      <i class="  fa-solid fa-users"></i>Users
                    </Link>
                    <Link to="/admin/all-admins">
                      {" "}
                      <i class="fa-solid fa-user-tie"></i>Admins
                    </Link>
                  </div>

                  <div className="goc-dashbord-left-side-menu-log-out-button">
                    <div onClick={() => setShowLogout(true)}>log out</div>
                  </div>
                </div>
              </div>

              {showNav ? (
                <div className="llluuu">
                  <span
                    className="goc-sm-navbar-close-btn"
                    onClick={() => setShowNav(false)}
                  >
                    <i class="fa-solid fa-circle-xmark"></i>
                  </span>

                  <div className="goc-dashbord-left-side-menu-container  goc-dashbord-left-side-menu-container-oluu ">
                    <div
                      onClick={() => setCompanyList(!companyList)}
                      className="goc-dashbord-left-side-menu-head"
                    >
                      {viewCompany}
                      {companyList ? (
                        <i className="fa-solid fa-angle-down"></i>
                      ) : (
                        <i className="fa-solid fa-angle-right"></i>
                      )}
                      {companyList ? (
                        <div className="goc-dashbord-left-side-menu-list">
                          <div
                            onClick={() => {
                              setViewCompany("Garage On Call");
                              setShowNav(false);
                            }}
                          >
                            Garage On Call
                          </div>
                          <div
                            onClick={() => {
                              setViewCompany("Repair Buddy");
                              setShowNav(false);
                            }}
                          >
                            Repair Buddy
                          </div>
                          <div
                            onClick={() => {
                              setViewCompany("Fluffy Touch");
                              setShowNav(false);
                            }}
                          >
                            Fluffy Touch
                          </div>
                          <div
                            onClick={() => {
                              setViewCompany("Glazma");
                              setShowNav(false);
                            }}
                          >
                            Glazma
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="goc-dashbord-left-side-menu-main-items-cont">
                      <div className="goc-dashbord-left-side-menu-items">
                        <Link onClick={() => setShowNav(false)} to="/admin">
                          {" "}
                          <i class="fa-solid fa-bookmark"></i>Bookings
                        </Link>

                        <Link
                          onClick={() => setShowNav(false)}
                          to="/admin/users"
                        >
                          {" "}
                          <i class="fa-solid fa-users"></i>Users
                        </Link>
                      </div>

                      <div className="goc-dashbord-left-side-menu-log-out-button">
                        <div onClick={() => setShowLogout(true)}>log out</div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="goc-dashbord-right-side-main-col">
              <Routes>
                <Route
                  path="/"
                  element={
                    <AdminDashboard
                      role="admin"
                      setShowLogout={setShowLogout}
                      logout={logout}
                      setShowNav={setShowNav}
                      viewCompany={viewCompany}
                    />
                  }
                />
                <Route
                  path="/users"
                  element={
                    <AdminUserComponent setShowNav={setShowNav} link={link} />
                  }
                />
                <Route
                  path="/all-admins"
                  element={
                    <AllAdminsComponent setShowNav={setShowNav} link={link} />
                  }
                />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminRoute;
